<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>帮助中心</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-collapse v-model="activeIndex">
      <van-collapse-item v-for="item in menuList" :key="item.id" :title="item.name" :name="item.id">
        <router-link tag="div" v-for="val in item.sub" :key="val.id" :to="val.tid == 1 ? `/help/sub-list?id=${val.id}&title=${val.name}` : `/help/detail?pid=${val.pid}&id=${val.id}&title=${val.name}`" class="row">
          <span>{{ val.name }}</span>
          <van-icon v-show="val.tid == 1" name="arrow" />
        </router-link>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCategory } from '@/api/common.js'
export default {
  name: 'HelpList',
  data() {
    return {
      activeIndex: [],
      menuList: [],
      initHeight: {} // 原始高度
    }
  },
  computed: {
    ...mapState(['agent'])
  },
  async created() {
    try {
      this.$store.commit('TOGGLE_LOADING', true)
      await this.getCategory()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async getCategory() {
      const res = await getCategory({ agent_uid: this.agent.id, type: 'help', pid: 0, sub: 1 })
      this.menuList = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 10px 10px;
  color: initial;
  &:not(:last-of-type){
    border-bottom: 1px solid #eee;
  }
  &:first-child{
    padding-top: 0;
  }
  &:last-child{
    padding-bottom: 0;
  }
  &:active{
    color: rgba(0, 0, 0, .9);
  }
}
</style>
